import api from "@/api/axios.js";

export async function listFieldRegistry()
{
	try
	{
		const {data} = await api.get("/api/fields");
		return data;
	}
	catch (e)
	{
		return {ok: false, error: e.response?.data?.error || e.message};
	}
}

export async function createFieldRegistry(payload)
{
	try
	{
		const {data} = await api.post("/api/fields", payload);
		return data;
	}
	catch (e)
	{
		return {ok: false, error: e.response?.data?.error || e.message};
	}
}

export async function updateFieldRegistry(id, payload)
{
	try
	{
		const {data} = await api.patch(`/api/fields/${id}`, payload);
		return data;
	}
	catch (e)
	{
		return {ok: false, error: e.response?.data?.error || e.message};
	}
}

// Salva ordine e colonna dei campi nell'editor card, valida per tutti i clienti:
// l'ordine dell'array e' la posizione (1..N), editorColumn 0 = automatica.
// xmlFollowsEditorLayout (opzionale) = lo stesso ordine vale anche per i tag dell'XML.
export async function updateFieldEditorLayout(fields, {xmlFollowsEditorLayout} = {})
{
	try
	{
		const {data} = await api.put("/api/fields/editor-layout", {fields, xmlFollowsEditorLayout});
		return data;
	}
	catch (e)
	{
		return {ok: false, error: e.response?.data?.error || e.message};
	}
}

export async function deleteFieldRegistry(id)
{
	try
	{
		const {data} = await api.delete(`/api/fields/${id}`);
		return data;
	}
	catch (e)
	{
		return {ok: false, error: e.response?.data?.error || e.message};
	}
}
